export const OPEN_MODAL = "modals/openModal";
export const CLOSE_MODAL = "modals/closeModal";
